import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Button, Dialog, Grid } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { ConfirmParts } from "pages/booking/dialogParts/ConfirmParts";
import { EventType } from "pages/statuses/EventType";
import * as CommonConstants from "utilities/CommonConstants";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backButton: {
            marginRight: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        cancelButton: {
            marginLeft: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        closeButton: {
            position: `absolute`,
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    })
);

interface Props {
    // 開くダイアログ選択
    isOpen: boolean;
    // 閉じる
    onClickCancel: VoidFunction;
    // 削除(キャンセル)
    onClickDelete: VoidFunction;
    // 予約変更ダイアログへ
    onClickNextToBookingChange: VoidFunction;
    // 予約情報
    booking: EventType;
    // ローディング状態のセッター
    setLoading: any;
}

/**
 * 予約変更・取消選択ダイアログコンポーネント
 * 予約の変更・取消が選択出来るコンポーネント
 * @param props
 *
 */
export const SelectBookingChangeOrDeleteDialog: React.FC<Props> = (props) => {
    const { isOpen, onClickCancel, onClickDelete, onClickNextToBookingChange, booking, setLoading } = props;
    const classes = useStyles();
    const isPcSize = useMediaQuery(CommonConstants.RESPONSIVE_MIN_WIDTH);

    const body = (
        <div>
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClickCancel}>
                <CloseIcon />
            </IconButton>
            <ConfirmParts booking={booking} setLoading={setLoading} />
            <Grid container>
                <Grid item xs={2} md={1}>
                    <Button color="primary" onClick={onClickCancel} className={classes.cancelButton}>
                        閉じる
                    </Button>
                </Grid>
                <Grid item xs={5} md={8}></Grid>
                <Grid item xs={2} md={1}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClickNextToBookingChange}
                        className={classes.backButton}
                    >
                        変更
                    </Button>
                </Grid>
                <Grid item xs={3} md={2}>
                    <Button variant="contained" color="primary" onClick={onClickDelete} className={classes.backButton}>
                        キャンセル
                    </Button>
                </Grid>
            </Grid>
        </div>
    );

    return (
        <Dialog
            maxWidth="md"
            fullScreen={!isPcSize}
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {body}
        </Dialog>
    );
};
